var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 5.83342C10.4583 5.83342 10.8333 6.20842 10.8333 6.66675V10.0001C10.8333 10.4584 10.4583 10.8334 9.99996 10.8334C9.54163 10.8334 9.16663 10.4584 9.16663 10.0001V6.66675C9.16663 6.20842 9.54163 5.83342 9.99996 5.83342ZM9.99163 1.66675C5.39163 1.66675 1.66663 5.40008 1.66663 10.0001C1.66663 14.6001 5.39163 18.3334 9.99163 18.3334C14.6 18.3334 18.3333 14.6001 18.3333 10.0001C18.3333 5.40008 14.6 1.66675 9.99163 1.66675ZM9.99996 16.6667C6.31663 16.6667 3.33329 13.6834 3.33329 10.0001C3.33329 6.31675 6.31663 3.33341 9.99996 3.33341C13.6833 3.33341 16.6666 6.31675 16.6666 10.0001C16.6666 13.6834 13.6833 16.6667 9.99996 16.6667ZM10.8333 14.1667H9.16663V12.5001H10.8333V14.1667Z",
    fill: "#F84960"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutline);
export default __webpack_public_path__ + "static/media/error-outline.7520f87f0adda11c2583dbede7457ca4.svg";
export { ForwardRef as ReactComponent };